module.exports = __webpack_public_path__ + "img/3.c8dece97.png";